module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    staticClass: "pa-0 ma-0",
    attrs: {
      "grid-list-md": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm9": "",
      "md12": ""
    }
  }, [(_vm.lAction === 'view') ? _c('v-tabs', {
    attrs: {
      "flat": "",
      "color": "primary",
      "dark": "",
      "grow": "",
      "height": "40",
      "fixed-tabs": ""
    },
    model: {
      value: (_vm.tab),
      callback: function($$v) {
        _vm.tab = $$v
      },
      expression: "tab"
    }
  }, _vm._l((_vm.tabitems), function(tabitem, n) {
    return _c('v-tab', {
      key: n,
      attrs: {
        "href": ("#tab-" + n)
      }
    }, [_vm._v("\n          " + _vm._s(tabitem) + "\n        ")])
  }), 1) : _vm._e(), _vm._v(" "), _c('v-tabs-items', {
    model: {
      value: (_vm.tab),
      callback: function($$v) {
        _vm.tab = $$v
      },
      expression: "tab"
    }
  }, [_vm._l((_vm.tabitems), function(tabitem, n) {
    return _c('v-tab-item', {
      key: n,
      attrs: {
        "value": ("tab-" + n)
      }
    }, [(tabitem === 'Asset') ? _c('v-layout', {
      staticClass: "mt-1 pa-2",
      attrs: {
        "row": "",
        "wrap": ""
      }
    }, [(_vm.lAction === 'view') ? _c('v-flex', {
      attrs: {
        "xs12": "",
        "md9": "",
        "mx-auto": ""
      }
    }, [_c('v-card-title', {
      staticClass: "title primary--text pa-2 pb-4"
    }, [_vm._v("\n                Search Asset\n              ")]), _vm._v(" "), _c('v-card', [_c('v-form', {
      ref: "sForm",
      refInFor: true,
      on: {
        "submit": function($event) {
          $event.preventDefault();
          return _vm.searchAssets()
        }
      }
    }, [_c('v-card-text', [_c('v-layout', {
      attrs: {
        "row": "",
        "wrap": ""
      }
    }, [_c('v-flex', {
      attrs: {
        "xs6": ""
      }
    }, [_c('v-text-field', {
      attrs: {
        "label": "Asset Name",
        "hide-details": "",
        "maxlength": "100"
      },
      model: {
        value: (_vm.lSearch.asset_name),
        callback: function($$v) {
          _vm.$set(_vm.lSearch, "asset_name", $$v)
        },
        expression: "lSearch.asset_name"
      }
    })], 1), _vm._v(" "), _c('v-flex', {
      attrs: {
        "xs6": ""
      }
    }, [_c('v-text-field', {
      attrs: {
        "label": "Asset Tag",
        "hide-details": "",
        "maxlength": "30"
      },
      model: {
        value: (_vm.lSearch.asset_tag),
        callback: function($$v) {
          _vm.$set(_vm.lSearch, "asset_tag", $$v)
        },
        expression: "lSearch.asset_tag"
      }
    })], 1), _vm._v(" "), _c('v-flex', {
      attrs: {
        "xs6": ""
      }
    }, [_c('v-select', {
      attrs: {
        "label": "Asset Category",
        "items": _vm.catList,
        "item-value": "asset_cat_id",
        "item-text": "asset_cat",
        "hide-details": "",
        "small-chips": "",
        "clearable": "",
        "multiple": ""
      },
      model: {
        value: (_vm.lSearch.asset_cat_list),
        callback: function($$v) {
          _vm.$set(_vm.lSearch, "asset_cat_list", $$v)
        },
        expression: "lSearch.asset_cat_list"
      }
    })], 1), _vm._v(" "), _c('v-flex', {
      attrs: {
        "xs6": ""
      }
    }, [_c('v-select', {
      attrs: {
        "label": "Location",
        "items": _vm.assetLocation,
        "item-text": "asset_location",
        "hide-details": "",
        "small-chips": "",
        "clearable": "",
        "multiple": ""
      },
      model: {
        value: (_vm.lSearch.asset_location_list),
        callback: function($$v) {
          _vm.$set(_vm.lSearch, "asset_location_list", $$v)
        },
        expression: "lSearch.asset_location_list"
      }
    })], 1), _vm._v(" "), _c('v-flex', {
      attrs: {
        "xs6": ""
      }
    }, [_c('v-select', {
      attrs: {
        "label": "AMC",
        "items": ['Under AMC', 'AMC Expired', 'No AMC'],
        "hide-details": ""
      },
      model: {
        value: (_vm.lSearch.amc),
        callback: function($$v) {
          _vm.$set(_vm.lSearch, "amc", $$v)
        },
        expression: "lSearch.amc"
      }
    })], 1), _vm._v(" "), _c('v-flex', {
      attrs: {
        "xs6": ""
      }
    }, [_c('v-select', {
      attrs: {
        "label": "Warranty",
        "items": ['Under Warranty', 'Warranty Expired', 'No Warranty'],
        "hide-details": ""
      },
      model: {
        value: (_vm.lSearch.warranty),
        callback: function($$v) {
          _vm.$set(_vm.lSearch, "warranty", $$v)
        },
        expression: "lSearch.warranty"
      }
    })], 1), _vm._v(" "), _c('v-flex', {
      attrs: {
        "xs6": "",
        "sm4": ""
      }
    }, [_c('v-checkbox', {
      staticClass: "my-label-text-size",
      attrs: {
        "label": "Critical",
        "hide-details": ""
      },
      model: {
        value: (_vm.lSearch.is_critical),
        callback: function($$v) {
          _vm.$set(_vm.lSearch, "is_critical", $$v)
        },
        expression: "lSearch.is_critical"
      }
    })], 1), _vm._v(" "), _c('v-flex', {
      attrs: {
        "xs6": "",
        "sm4": ""
      }
    }, [_c('v-checkbox', {
      staticClass: "my-label-text-size",
      attrs: {
        "label": "Non-critical",
        "hide-details": ""
      },
      model: {
        value: (_vm.lSearch.non_critical),
        callback: function($$v) {
          _vm.$set(_vm.lSearch, "non_critical", $$v)
        },
        expression: "lSearch.non_critical"
      }
    })], 1)], 1)], 1), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
      on: {
        "click": _vm.clear
      }
    }, [_vm._v("clear")]), _vm._v(" "), _c('v-btn', {
      attrs: {
        "color": "accent",
        "type": "submit",
        "disabled": _vm.beingSaved
      }
    }, [_vm._v("search")])], 1)], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.lAction === 'view' && _vm.assetList.length > 0) ? _c('v-flex', {
      staticClass: "mx-auto",
      attrs: {
        "xs12": ""
      }
    }, [_c('v-card-title', {
      staticClass: "title primary--text"
    }, [_vm._v("\n          Search Result (" + _vm._s(_vm.assetList.length) + " Records)\n        ")]), _vm._v(" "), _c('v-layout', [_c('v-flex', {
      staticClass: "text-xs-right pa-0",
      attrs: {
        "xs12": ""
      }
    }, [_c('v-download-as', {
      attrs: {
        "headers": _vm.assHead,
        "items": _vm.assetList,
        "title": "Asset List",
        "landscape": true,
        "fontsize": 8
      }
    })], 1)], 1), _vm._v(" "), _c('v-data-table', {
      staticClass: "elevation-3 mt-3",
      attrs: {
        "headers": _vm.$vuetify.breakpoint.smAndUp ? _vm.assHead : _vm.assHeadsm,
        "items": _vm.assetList,
        "disable-initial-sort": "",
        "rows-per-page-items": [10, 25, 50, {
          'text': '$vuetify.dataIterator.rowsPerPageAll',
          'value': -1
        }],
        "pagination": _vm.pagination,
        "search": _vm.search
      },
      on: {
        "update:pagination": function($event) {
          _vm.pagination = $event
        }
      },
      scopedSlots: _vm._u([{
        key: "items",
        fn: function(props) {
          return [_c('tr', [(_vm.$vuetify.breakpoint.smAndUp) ? _c('td', {
            staticClass: "pa-3"
          }, [_vm._v(_vm._s(props.item.asset_cat))]) : _vm._e(), _vm._v(" "), _c('td', {
            staticClass: "pa-3"
          }, [_vm._v(_vm._s(props.item.asset_name))]), _vm._v(" "), _c('td', {
            staticClass: "pa-3"
          }, [_vm._v(_vm._s(props.item.asset_qty))]), _vm._v(" "), (_vm.$vuetify.breakpoint.smAndUp) ? _c('td', {
            staticClass: "pa-3"
          }, [_vm._v(_vm._s(props.item.asset_tag))]) : _vm._e(), _vm._v(" "), (_vm.$vuetify.breakpoint.smAndUp) ? _c('td', {
            staticClass: "pa-3"
          }, [_vm._v(_vm._s(props.item.is_under_warranty))]) : _vm._e(), _vm._v(" "), (_vm.$vuetify.breakpoint.smAndUp) ? _c('td', {
            class: (props.item.warranty_end_dt && _vm.handy.formatDBDate(props.item.warranty_end_dt)) <= _vm.today ? 'error pa-3' : 'pa-3'
          }, [_vm._v(_vm._s(props.item.warranty_end_dt ? _vm.handy.formatDBDate(props.item.warranty_end_dt) : ''))]) : _vm._e(), _vm._v(" "), (_vm.$vuetify.breakpoint.smAndUp) ? _c('td', {
            staticClass: "pa-3"
          }, [_vm._v(_vm._s(props.item.is_under_amc))]) : _vm._e(), _vm._v(" "), (_vm.$vuetify.breakpoint.smAndUp) ? _c('td', {
            class: (props.item.amc_due_dt && _vm.handy.formatDBDate(props.item.amc_due_dt)) <= _vm.today ? 'error pa-3' : 'pa-3'
          }, [_vm._v(_vm._s(props.item.amc_due_dt ? _vm.handy.formatDBDate(props.item.amc_due_dt) : ''))]) : _vm._e(), _vm._v(" "), (_vm.$vuetify.breakpoint.smAndUp) ? _c('td', {
            staticClass: "pa-3"
          }, [_vm._v(_vm._s(props.item.is_critical ? 'Yes' : 'No'))]) : _vm._e(), _vm._v(" "), _c('v-menu', {
            staticClass: "mt-2",
            attrs: {
              "bottom": "",
              "right": ""
            }
          }, [_c('span', {
            attrs: {
              "slot": "activator"
            },
            slot: "activator"
          }, [_c('v-btn', {
            staticClass: "ma-0",
            attrs: {
              "slot": "activator",
              "small": "",
              "icon": ""
            },
            slot: "activator"
          }, [_c('v-icon', [_vm._v("more_vert")])], 1)], 1), _vm._v(" "), _c('v-list', [_c('v-list-tile', {
            on: {
              "click": function($event) {
                return _vm.prepareUpdate(props.item)
              }
            }
          }, [_c('v-list-tile-avatar', [_c('v-icon', [_vm._v("edit")])], 1), _vm._v(" "), _c('v-list-tile-title', [_vm._v("Update")])], 1), _vm._v(" "), _c('v-list-tile', {
            on: {
              "click": function($event) {
                return _vm.prepareHist(props.item)
              }
            }
          }, [_c('v-list-tile-avatar', [_c('v-icon', [_vm._v("history")])], 1), _vm._v(" "), _c('v-list-tile-title', [_vm._v("Service History")])], 1)], 1)], 1)], 1)]
        }
      }], null, true)
    })], 1) : _vm._e()], 1) : _c('v-layout', {
      staticClass: "mt-1 pa-2",
      attrs: {
        "row": "",
        "wrap": ""
      }
    }, [(_vm.lAction === 'view') ? _c('v-flex', {
      staticClass: "mx-auto",
      attrs: {
        "xs12": "",
        "md9": ""
      }
    }, [_c('v-layout', {
      attrs: {
        "row": "",
        "wrap": ""
      }
    }, [_c('v-flex', {
      attrs: {
        "xs6": ""
      }
    }, [_c('v-text-field', {
      staticClass: "pa-0 mt-1",
      attrs: {
        "append-icon": "search",
        "placeholder": _vm.$vuetify.breakpoint.smAndUp ? 'Search by Consumable name, Category, etc.' : 'Search',
        "single-line": "",
        "hide-details": "",
        "clearable": ""
      },
      model: {
        value: (_vm.search),
        callback: function($$v) {
          _vm.search = $$v
        },
        expression: "search"
      }
    })], 1), _vm._v(" "), _c('v-flex', {
      attrs: {
        "xs6": ""
      }
    }, [_c('v-download-as', {
      attrs: {
        "headers": _vm.consHead,
        "items": _vm.consList,
        "title": "Consumable List"
      }
    })], 1)], 1), _vm._v(" "), _c('v-data-table', {
      staticClass: "elevation-3 mt-3",
      attrs: {
        "headers": _vm.$vuetify.breakpoint.smAndUp ? _vm.consHead : _vm.consHeadsm,
        "items": _vm.consList,
        "hide-actions": "",
        "disable-initial-sort": "",
        "search": _vm.search
      },
      scopedSlots: _vm._u([{
        key: "items",
        fn: function(props) {
          return [_c('tr', [(_vm.$vuetify.breakpoint.smAndUp) ? _c('td', [_vm._v(_vm._s(props.item.cons_cat))]) : _vm._e(), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.cons_name))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.cons_stock_uom))]), _vm._v(" "), _c('v-menu', {
            staticClass: "mt-2",
            attrs: {
              "bottom": "",
              "left": ""
            }
          }, [_c('span', {
            attrs: {
              "slot": "activator"
            },
            slot: "activator"
          }, [_c('v-btn', {
            staticClass: "ma-0",
            attrs: {
              "slot": "activator",
              "small": "",
              "icon": ""
            },
            slot: "activator"
          }, [_c('v-icon', [_vm._v("more_vert")])], 1)], 1), _vm._v(" "), _c('v-list', [_c('v-list-tile', {
            on: {
              "click": function($event) {
                return _vm.increaceStock(props.item)
              }
            }
          }, [_c('v-list-tile-avatar', [_c('v-icon', [_vm._v("add")])], 1), _vm._v(" "), _c('v-list-tile-title', [_vm._v("Increment Stock")])], 1), _vm._v(" "), _c('v-list-tile', {
            on: {
              "click": function($event) {
                return _vm.decreaseStock(props.item)
              }
            }
          }, [_c('v-list-tile-avatar', [_c('v-icon', [_vm._v("remove")])], 1), _vm._v(" "), _c('v-list-tile-title', [_vm._v("Decrement Stock")])], 1), _vm._v(" "), _c('v-list-tile', {
            on: {
              "click": function($event) {
                return _vm.prepareUpdateconsumable(props.item)
              }
            }
          }, [_c('v-list-tile-avatar', [_c('v-icon', [_vm._v("edit")])], 1), _vm._v(" "), _c('v-list-tile-title', [_vm._v("Update Consumable Details")])], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-list-tile', {
            on: {
              "click": function($event) {
                return _vm.prepareConsumableReport(props.item)
              }
            }
          }, [_c('v-list-tile-avatar', [_c('v-icon', [_vm._v("report")])], 1), _vm._v(" "), _c('v-list-tile-title', [_vm._v("Consumable Report")])], 1)], 1)], 1)], 1)]
        }
      }], null, true)
    })], 1) : _vm._e()], 1)], 1)
  }), _vm._v(" "), (_vm.lAction === 'view') ? _c('v-tooltip', {
    attrs: {
      "top": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-btn', _vm._g({
          style: ('position:fixed; ' + (_vm.$vuetify.breakpoint.smAndDown ? 'bottom:15px; left:65px;' : 'bottom:15px; left:410px;')),
          attrs: {
            "dark": "",
            "fab": "",
            "fixed": "",
            "color": "accent"
          },
          nativeOn: {
            "click": function($event) {
              _vm.tab === 'tab-0' ? _vm.prepareAsset() : _vm.prepareConsumable()
            }
          }
        }, on), [_c('v-icon', [_vm._v("add")])], 1)]
      }
    }], null, false, 876065766)
  }, [_vm._v(" "), _c('span', {
    staticClass: "caption"
  }, [_vm._v("Create Asset")])]) : _vm._e(), _vm._v(" "), (_vm.lAction === 'view' && _vm.tab === 'tab-0') ? _c('v-tooltip', {
    attrs: {
      "top": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-btn', _vm._g({
          style: ('position:fixed; ' + (_vm.$vuetify.breakpoint.smAndDown ? 'bottom:15px; left:15px;' : 'bottom:15px; left:360px;')),
          attrs: {
            "dark": "",
            "fab": "",
            "fixed": "",
            "small": "",
            "color": "accent"
          },
          nativeOn: {
            "click": function($event) {
              return _vm.prepareUpload($event)
            }
          }
        }, on), [_c('v-icon', [_vm._v("file_upload")])], 1)]
      }
    }], null, false, 2699628612)
  }, [_vm._v(" "), _c('span', {
    staticClass: "caption"
  }, [_vm._v("Upload Asset")])]) : _vm._e(), _vm._v(" "), (_vm.lAction === 'view' && _vm.tab === 'tab-0') ? _c('v-tooltip', {
    attrs: {
      "top": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-btn', _vm._g({
          style: ('position:fixed; ' + (_vm.$vuetify.breakpoint.smAndDown ? 'bottom:15px; left:15px;' : 'bottom:15px; left:310px;')),
          attrs: {
            "dark": "",
            "fab": "",
            "fixed": "",
            "small": "",
            "color": "accent"
          },
          nativeOn: {
            "click": function($event) {
              return _vm.prepareSerHistUpload($event)
            }
          }
        }, on), [_c('v-icon', [_vm._v("build")])], 1)]
      }
    }], null, false, 4133882637)
  }, [_vm._v(" "), _c('span', {
    staticClass: "caption"
  }, [_vm._v("Upload Asset Service History")])]) : _vm._e()], 2), _vm._v(" "), (_vm.lAction === 'create' || _vm.lAction === 'update') ? _c('v-container', {
    staticClass: "pa-0",
    attrs: {
      "fluid": "",
      "full-height": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [(_vm.lAsset) ? _c('v-flex', {
    staticClass: "mt-0 pt-0",
    attrs: {
      "xs12": "",
      "sm9": "",
      "md6": "",
      "mx-auto": ""
    }
  }, [_c('v-form', {
    ref: "lForm",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.saveChanges(_vm.lAction)
      }
    }
  }, [_c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-card-text', {
    staticClass: "pt-0"
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs10": ""
    }
  }, [_c('v-select', {
    attrs: {
      "label": "Category",
      "items": _vm.catList,
      "item-value": "asset_cat_id",
      "item-text": "asset_cat",
      "return-object": "",
      "rules": [_vm.rules.required],
      "hide-details": ""
    },
    model: {
      value: (_vm.lAsset.asset_cat_pair),
      callback: function($$v) {
        _vm.$set(_vm.lAsset, "asset_cat_pair", $$v)
      },
      expression: "lAsset.asset_cat_pair"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs2": ""
    }
  }, [_c('v-btn', {
    staticClass: "grey lighten-2 mt-2",
    attrs: {
      "icon": ""
    },
    on: {
      "click": _vm.prepareCategory
    }
  }, [_c('v-icon', [_vm._v("add")])], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Name",
      "rules": [_vm.rules.required],
      "hide-details": "",
      "maxlength": "100"
    },
    model: {
      value: (_vm.lAsset.asset_name),
      callback: function($$v) {
        _vm.$set(_vm.lAsset, "asset_name", $$v)
      },
      expression: "lAsset.asset_name"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Location",
      "rules": [_vm.rules.required],
      "hide-details": "",
      "maxlength": "100"
    },
    model: {
      value: (_vm.lAsset.asset_location),
      callback: function($$v) {
        _vm.$set(_vm.lAsset, "asset_location", $$v)
      },
      expression: "lAsset.asset_location"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Quantity",
      "rules": [_vm.rules.required],
      "hide-details": "",
      "type": "number"
    },
    model: {
      value: (_vm.lAsset.asset_qty),
      callback: function($$v) {
        _vm.$set(_vm.lAsset, "asset_qty", $$v)
      },
      expression: "lAsset.asset_qty"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('v-select', {
    attrs: {
      "label": "Asset status",
      "items": ['Operational', 'Idle', 'Broken', 'In Repair', 'Missing', 'Decommissioned'],
      "hide-details": ""
    },
    model: {
      value: (_vm.lAsset.asset_status),
      callback: function($$v) {
        _vm.$set(_vm.lAsset, "asset_status", $$v)
      },
      expression: "lAsset.asset_status"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Asset tag",
      "rules": [_vm.rules.required],
      "hide-details": "",
      "maxlength": "30"
    },
    model: {
      value: (_vm.lAsset.asset_tag),
      callback: function($$v) {
        _vm.$set(_vm.lAsset, "asset_tag", $$v)
      },
      expression: "lAsset.asset_tag"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('v-checkbox', {
    staticClass: "my-label-text-size",
    attrs: {
      "label": "Critical asset",
      "hide-details": ""
    },
    model: {
      value: (_vm.lAsset.is_critical),
      callback: function($$v) {
        _vm.$set(_vm.lAsset, "is_critical", $$v)
      },
      expression: "lAsset.is_critical"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "pt-4",
    attrs: {
      "xs12": ""
    }
  }, [_c('span', {
    staticClass: "primary--text subheader pa-0"
  }, [_vm._v("Additional Information (Optional)")])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Specification",
      "hide-details": "",
      "maxlength": "150"
    },
    model: {
      value: (_vm.lAsset.asset_spec),
      callback: function($$v) {
        _vm.$set(_vm.lAsset, "asset_spec", $$v)
      },
      expression: "lAsset.asset_spec"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('v-dialog', {
    ref: "dlgpurchaseDt",
    staticClass: "pt-0",
    attrs: {
      "persistent": "",
      "lazy": "",
      "max-width": "290px",
      "return-value": _vm.lAsset.purchased_dt
    },
    on: {
      "update:returnValue": function($event) {
        return _vm.$set(_vm.lAsset, "purchased_dt", $event)
      },
      "update:return-value": function($event) {
        return _vm.$set(_vm.lAsset, "purchased_dt", $event)
      }
    },
    model: {
      value: (_vm.dlgpurchaseDt),
      callback: function($$v) {
        _vm.dlgpurchaseDt = $$v
      },
      expression: "dlgpurchaseDt"
    }
  }, [_c('v-text-field', {
    attrs: {
      "slot": "activator",
      "label": "Purchase/commissioned date",
      "append-icon": "event",
      "readonly": "",
      "hide-details": "",
      "clearable": ""
    },
    slot: "activator",
    model: {
      value: (_vm.lAsset.purchased_dt),
      callback: function($$v) {
        _vm.$set(_vm.lAsset, "purchased_dt", $$v)
      },
      expression: "lAsset.purchased_dt"
    }
  }), _vm._v(" "), _c('v-date-picker', {
    attrs: {
      "scrollable": "",
      "max": _vm.today,
      "first-day-of-week": "1"
    },
    model: {
      value: (_vm.lAsset.purchased_dt),
      callback: function($$v) {
        _vm.$set(_vm.lAsset, "purchased_dt", $$v)
      },
      expression: "lAsset.purchased_dt"
    }
  }, [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": ""
    },
    on: {
      "click": function($event) {
        _vm.dlgpurchaseDt = false
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": "",
      "color": "accent"
    },
    on: {
      "click": function($event) {
        return _vm.$refs.dlgpurchaseDt.save(_vm.lAsset.purchased_dt)
      }
    }
  }, [_vm._v("OK")])], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Asset value",
      "hide-details": "",
      "type": "number"
    },
    model: {
      value: (_vm.lAsset.asset_value),
      callback: function($$v) {
        _vm.$set(_vm.lAsset, "asset_value", $$v)
      },
      expression: "lAsset.asset_value"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-combobox', {
    attrs: {
      "label": "Choose vendor",
      "items": _vm.vendors.map(function (rec) { return rec.vendor_name; }),
      "maxlength": "50",
      "hide-details": ""
    },
    on: {
      "input": function($event) {
        return _vm.findVendor(_vm.lAsset)
      }
    },
    model: {
      value: (_vm.lAsset.vendor_name),
      callback: function($$v) {
        _vm.$set(_vm.lAsset, "vendor_name", $$v)
      },
      expression: "lAsset.vendor_name"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "pt-4",
    attrs: {
      "xs12": ""
    }
  }, [_c('span', {
    staticClass: "primary--text subheader pa-0"
  }, [_vm._v("Warranty and AMC (Optional)")])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('v-dialog', {
    ref: "dlgwarrantyStartDt",
    staticClass: "pt-0",
    attrs: {
      "persistent": "",
      "lazy": "",
      "max-width": "290px",
      "return-value": _vm.lAsset.warranty_start_dt
    },
    on: {
      "update:returnValue": function($event) {
        return _vm.$set(_vm.lAsset, "warranty_start_dt", $event)
      },
      "update:return-value": function($event) {
        return _vm.$set(_vm.lAsset, "warranty_start_dt", $event)
      }
    },
    model: {
      value: (_vm.dlgwarrantyStartDt),
      callback: function($$v) {
        _vm.dlgwarrantyStartDt = $$v
      },
      expression: "dlgwarrantyStartDt"
    }
  }, [_c('v-text-field', {
    attrs: {
      "slot": "activator",
      "label": "Warranty start date",
      "append-icon": "event",
      "readonly": "",
      "hide-details": "",
      "clearable": ""
    },
    slot: "activator",
    model: {
      value: (_vm.lAsset.warranty_start_dt),
      callback: function($$v) {
        _vm.$set(_vm.lAsset, "warranty_start_dt", $$v)
      },
      expression: "lAsset.warranty_start_dt"
    }
  }), _vm._v(" "), _c('v-date-picker', {
    attrs: {
      "scrollable": "",
      "first-day-of-week": "1"
    },
    model: {
      value: (_vm.lAsset.warranty_start_dt),
      callback: function($$v) {
        _vm.$set(_vm.lAsset, "warranty_start_dt", $$v)
      },
      expression: "lAsset.warranty_start_dt"
    }
  }, [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": ""
    },
    on: {
      "click": function($event) {
        _vm.dlgwarrantyStartDt = false
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": "",
      "color": "accent"
    },
    on: {
      "click": function($event) {
        return _vm.$refs.dlgwarrantyStartDt.save(_vm.lAsset.warranty_start_dt)
      }
    }
  }, [_vm._v("OK")])], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('v-dialog', {
    ref: "dlgwarrantyEndDt",
    staticClass: "pt-0",
    attrs: {
      "persistent": "",
      "lazy": "",
      "max-width": "290px",
      "return-value": _vm.lAsset.warranty_end_dt
    },
    on: {
      "update:returnValue": function($event) {
        return _vm.$set(_vm.lAsset, "warranty_end_dt", $event)
      },
      "update:return-value": function($event) {
        return _vm.$set(_vm.lAsset, "warranty_end_dt", $event)
      }
    },
    model: {
      value: (_vm.dlgwarrantyEndDt),
      callback: function($$v) {
        _vm.dlgwarrantyEndDt = $$v
      },
      expression: "dlgwarrantyEndDt"
    }
  }, [_c('v-text-field', {
    attrs: {
      "slot": "activator",
      "label": "Warranty end date",
      "append-icon": "event",
      "readonly": "",
      "hide-details": "",
      "clearable": ""
    },
    slot: "activator",
    model: {
      value: (_vm.lAsset.warranty_end_dt),
      callback: function($$v) {
        _vm.$set(_vm.lAsset, "warranty_end_dt", $$v)
      },
      expression: "lAsset.warranty_end_dt"
    }
  }), _vm._v(" "), _c('v-date-picker', {
    attrs: {
      "scrollable": "",
      "first-day-of-week": "1"
    },
    model: {
      value: (_vm.lAsset.warranty_end_dt),
      callback: function($$v) {
        _vm.$set(_vm.lAsset, "warranty_end_dt", $$v)
      },
      expression: "lAsset.warranty_end_dt"
    }
  }, [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": ""
    },
    on: {
      "click": function($event) {
        _vm.dlgwarrantyEndDt = false
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": "",
      "color": "accent"
    },
    on: {
      "click": function($event) {
        return _vm.$refs.dlgwarrantyEndDt.save(_vm.lAsset.warranty_end_dt)
      }
    }
  }, [_vm._v("OK")])], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('v-dialog', {
    ref: "dlgAmcStartDt",
    attrs: {
      "persistent": "",
      "lazy": "",
      "max-width": "290px",
      "return-value": _vm.lAsset.amc_start_dt
    },
    on: {
      "update:returnValue": function($event) {
        return _vm.$set(_vm.lAsset, "amc_start_dt", $event)
      },
      "update:return-value": function($event) {
        return _vm.$set(_vm.lAsset, "amc_start_dt", $event)
      }
    },
    model: {
      value: (_vm.dlgAmcStartDt),
      callback: function($$v) {
        _vm.dlgAmcStartDt = $$v
      },
      expression: "dlgAmcStartDt"
    }
  }, [_c('v-text-field', {
    attrs: {
      "slot": "activator",
      "label": "AMC start date",
      "append-icon": "event",
      "readonly": "",
      "clearable": "",
      "hide-details": ""
    },
    slot: "activator",
    model: {
      value: (_vm.lAsset.amc_start_dt),
      callback: function($$v) {
        _vm.$set(_vm.lAsset, "amc_start_dt", $$v)
      },
      expression: "lAsset.amc_start_dt"
    }
  }), _vm._v(" "), _c('v-date-picker', {
    attrs: {
      "scrollable": "",
      "first-day-of-week": "1"
    },
    model: {
      value: (_vm.lAsset.amc_start_dt),
      callback: function($$v) {
        _vm.$set(_vm.lAsset, "amc_start_dt", $$v)
      },
      expression: "lAsset.amc_start_dt"
    }
  }, [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": ""
    },
    on: {
      "click": function($event) {
        _vm.dlgAmcStartDt = false
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": "",
      "color": "accent"
    },
    on: {
      "click": function($event) {
        return _vm.$refs.dlgAmcStartDt.save(_vm.lAsset.amc_start_dt)
      }
    }
  }, [_vm._v("OK")])], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('v-dialog', {
    ref: "dlgBookDt",
    attrs: {
      "persistent": "",
      "lazy": "",
      "max-width": "290px",
      "return-value": _vm.lAsset.amc_due_dt
    },
    on: {
      "update:returnValue": function($event) {
        return _vm.$set(_vm.lAsset, "amc_due_dt", $event)
      },
      "update:return-value": function($event) {
        return _vm.$set(_vm.lAsset, "amc_due_dt", $event)
      }
    },
    model: {
      value: (_vm.dlgBookDt),
      callback: function($$v) {
        _vm.dlgBookDt = $$v
      },
      expression: "dlgBookDt"
    }
  }, [_c('v-text-field', {
    attrs: {
      "slot": "activator",
      "label": "AMC due date",
      "append-icon": "event",
      "readonly": "",
      "clearable": "",
      "hide-details": ""
    },
    slot: "activator",
    model: {
      value: (_vm.lAsset.amc_due_dt),
      callback: function($$v) {
        _vm.$set(_vm.lAsset, "amc_due_dt", $$v)
      },
      expression: "lAsset.amc_due_dt"
    }
  }), _vm._v(" "), _c('v-date-picker', {
    attrs: {
      "scrollable": "",
      "first-day-of-week": "1"
    },
    model: {
      value: (_vm.lAsset.amc_due_dt),
      callback: function($$v) {
        _vm.$set(_vm.lAsset, "amc_due_dt", $$v)
      },
      expression: "lAsset.amc_due_dt"
    }
  }, [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": ""
    },
    on: {
      "click": function($event) {
        _vm.dlgBookDt = false
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": "",
      "color": "accent"
    },
    on: {
      "click": function($event) {
        return _vm.$refs.dlgBookDt.save(_vm.lAsset.amc_due_dt)
      }
    }
  }, [_vm._v("OK")])], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('v-dialog', {
    ref: "dlgserviceDt",
    staticClass: "pt-0",
    attrs: {
      "persistent": "",
      "lazy": "",
      "max-width": "290px",
      "return-value": _vm.lAsset.next_service_due_dt
    },
    on: {
      "update:returnValue": function($event) {
        return _vm.$set(_vm.lAsset, "next_service_due_dt", $event)
      },
      "update:return-value": function($event) {
        return _vm.$set(_vm.lAsset, "next_service_due_dt", $event)
      }
    },
    model: {
      value: (_vm.dlgserviceDt),
      callback: function($$v) {
        _vm.dlgserviceDt = $$v
      },
      expression: "dlgserviceDt"
    }
  }, [_c('v-text-field', {
    attrs: {
      "slot": "activator",
      "label": "Next service due date",
      "append-icon": "event",
      "readonly": "",
      "hide-details": "",
      "clearable": ""
    },
    slot: "activator",
    model: {
      value: (_vm.lAsset.next_service_due_dt),
      callback: function($$v) {
        _vm.$set(_vm.lAsset, "next_service_due_dt", $$v)
      },
      expression: "lAsset.next_service_due_dt"
    }
  }), _vm._v(" "), _c('v-date-picker', {
    attrs: {
      "scrollable": "",
      "min": _vm.today,
      "first-day-of-week": "1"
    },
    model: {
      value: (_vm.lAsset.next_service_due_dt),
      callback: function($$v) {
        _vm.$set(_vm.lAsset, "next_service_due_dt", $$v)
      },
      expression: "lAsset.next_service_due_dt"
    }
  }, [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": ""
    },
    on: {
      "click": function($event) {
        _vm.dlgserviceDt = false
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": "",
      "color": "accent"
    },
    on: {
      "click": function($event) {
        return _vm.$refs.dlgserviceDt.save(_vm.lAsset.next_service_due_dt)
      }
    }
  }, [_vm._v("OK")])], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-textarea', {
    attrs: {
      "label": "Remarks",
      "hide-details": "",
      "rows": "2",
      "maxlength": "150"
    },
    model: {
      value: (_vm.lAsset.remark),
      callback: function($$v) {
        _vm.$set(_vm.lAsset, "remark", $$v)
      },
      expression: "lAsset.remark"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.cancelChanges($event)
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), (_vm.lAction === 'update') ? _c('v-btn', {
    attrs: {
      "disabled": _vm.beingSaved
    },
    nativeOn: {
      "click": function($event) {
        return _vm.deleteAsset(_vm.lAsset)
      }
    }
  }, [_vm._v("Delete")]) : _vm._e(), _vm._v(" "), _c('v-btn', {
    attrs: {
      "type": "submit",
      "color": "accent",
      "disabled": _vm.beingSaved
    }
  }, [_vm._v("Save")])], 1)], 1)], 1)], 1) : _vm._e()], 1)], 1) : _vm._e(), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "persistent": "",
      "max-width": "500px"
    },
    model: {
      value: (_vm.manageAssetCat),
      callback: function($$v) {
        _vm.manageAssetCat = $$v
      },
      expression: "manageAssetCat"
    }
  }, [(_vm.lMAction === 'view') ? _c('v-card', {
    attrs: {
      "scrollable": ""
    }
  }, [_c('v-card-title', {
    staticClass: "title grey lighten-4"
  }, [_vm._v("\n      Asset Category\n      "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "small": "",
      "icon": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.manageAssetCat = false
      }
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)], 1), _vm._v(" "), _c('v-card-text', [_c('v-flex', {
    staticClass: "mx-auto",
    attrs: {
      "xs12": "",
      "sm9": "",
      "md12": ""
    }
  }, [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    staticClass: "mb-0",
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "color": "accent",
      "flat": ""
    },
    on: {
      "click": _vm.createManageAsset
    }
  }, [_vm._v("Add New")]), _vm._v(" "), _c('v-data-table', {
    staticClass: "elevation-1",
    attrs: {
      "headers": _vm.ManageAssHead,
      "items": _vm.catList,
      "hide-actions": "",
      "disable-initial-sort": ""
    },
    scopedSlots: _vm._u([{
      key: "items",
      fn: function(props) {
        return [_c('tr', {
          on: {
            "click": function($event) {
              return _vm.prepareEdit(props.item)
            }
          }
        }, [_c('td', [_vm._v(_vm._s(props.item.asset_cat))])])]
      }
    }], null, false, 100447085)
  })], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.lMAction === 'create' || _vm.lMAction === 'update') ? _c('v-container', {
    staticClass: "pa-0",
    attrs: {
      "fluid": "",
      "full-height": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-form', {
    ref: "acForm",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.saveAssetCat(_vm.lMAction)
      }
    }
  }, [_c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-flex', {
    staticClass: "mx-auto",
    attrs: {
      "xs12": ""
    }
  }, [_c('v-card-title', {
    staticClass: "title pb-0"
  }, [_vm._v("\n              " + _vm._s(_vm.handy.startWithUpper(_vm.lMAction)) + " Asset Category\n            ")]), _vm._v(" "), _c('v-card-text', [_c('v-text-field', {
    attrs: {
      "label": "Category name",
      "rules": [_vm.rules.required],
      "hide-details": "",
      "maxlength": "100"
    },
    model: {
      value: (_vm.lCat.asset_cat),
      callback: function($$v) {
        _vm.$set(_vm.lCat, "asset_cat", $$v)
      },
      expression: "lCat.asset_cat"
    }
  })], 1)], 1), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.cancelChangesCat($event)
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), (_vm.lMAction === 'update') ? _c('v-btn', {
    attrs: {
      "flat": "",
      "disabled": _vm.beingSaved
    },
    on: {
      "click": function($event) {
        return _vm.deleteCat(_vm.lCat)
      }
    }
  }, [_vm._v("Delete")]) : _vm._e(), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": "",
      "type": "submit",
      "color": "accent",
      "disabled": _vm.beingSaved
    }
  }, [_vm._v("Save")])], 1)], 1)], 1)], 1)], 1)], 1) : _vm._e()], 1), _vm._v(" "), (_vm.lAction === 'create-cons' || _vm.lAction === 'update-cons') ? _c('v-container', {
    staticClass: "pa-0",
    attrs: {
      "fluid": "",
      "full-height": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm9": "",
      "md6": "",
      "mx-auto": ""
    }
  }, [_c('v-form', {
    ref: "cForm",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.saveChangesConsumable(_vm.lAction)
      }
    }
  }, [_c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-card-text', {
    staticClass: "pt-0"
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs10": ""
    }
  }, [_c('v-select', {
    attrs: {
      "label": "Category",
      "items": _vm.consCatList,
      "item-text": "cons_cat",
      "item-value": "cons_cat_id",
      "return-object": "",
      "rules": [_vm.rules.required],
      "hide-details": ""
    },
    model: {
      value: (_vm.lCons.cons_cat_pair),
      callback: function($$v) {
        _vm.$set(_vm.lCons, "cons_cat_pair", $$v)
      },
      expression: "lCons.cons_cat_pair"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs2": ""
    }
  }, [_c('v-btn', {
    staticClass: "grey lighten-2 mt-2",
    attrs: {
      "icon": ""
    },
    on: {
      "click": _vm.prepareConsCategory
    }
  }, [_c('v-icon', [_vm._v("add")])], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Consumable name",
      "rules": [_vm.rules.required],
      "hide-details": "",
      "maxlength": "100"
    },
    model: {
      value: (_vm.lCons.cons_name),
      callback: function($$v) {
        _vm.$set(_vm.lCons, "cons_name", $$v)
      },
      expression: "lCons.cons_name"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": "",
      "sm3": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "disabled": _vm.lAction === 'update-cons',
      "label": "Stock",
      "rules": [_vm.rules.required],
      "hide-details": "",
      "type": "number"
    },
    model: {
      value: (_vm.lCons.cons_stock),
      callback: function($$v) {
        _vm.$set(_vm.lCons, "cons_stock", $$v)
      },
      expression: "lCons.cons_stock"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": "",
      "sm3": ""
    }
  }, [_c('v-combobox', {
    attrs: {
      "label": "UOM",
      "rules": [_vm.rules.required],
      "items": ['nos', 'ltr', 'kg', 'm', 'ft'],
      "maxlength": "25",
      "hide-details": ""
    },
    model: {
      value: (_vm.lCons.cons_uom),
      callback: function($$v) {
        _vm.$set(_vm.lCons, "cons_uom", $$v)
      },
      expression: "lCons.cons_uom"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "md12": ""
    }
  }, [_c('v-combobox', {
    attrs: {
      "label": "Choose vendor (optional)",
      "items": _vm.vendors.map(function (rec) { return rec.vendor_name; }),
      "maxlength": "50",
      "hide-details": ""
    },
    on: {
      "input": function($event) {
        return _vm.findVendor(_vm.lCons)
      }
    },
    model: {
      value: (_vm.lCons.vendor_name),
      callback: function($$v) {
        _vm.$set(_vm.lCons, "vendor_name", $$v)
      },
      expression: "lCons.vendor_name"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.cancelChanges($event)
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), (_vm.lAction === 'update-cons') ? _c('v-btn', {
    attrs: {
      "disabled": _vm.beingSaved
    },
    nativeOn: {
      "click": function($event) {
        return _vm.deleteCons(_vm.lCons)
      }
    }
  }, [_vm._v("Delete")]) : _vm._e(), _vm._v(" "), _c('v-btn', {
    attrs: {
      "type": "submit",
      "color": "accent",
      "disabled": _vm.beingSaved
    }
  }, [_vm._v("Save")])], 1)], 1)], 1)], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "persistent": "",
      "max-width": "500px"
    },
    model: {
      value: (_vm.manageConsCat),
      callback: function($$v) {
        _vm.manageConsCat = $$v
      },
      expression: "manageConsCat"
    }
  }, [(_vm.lConsAction === 'view') ? _c('v-card', {
    attrs: {
      "scrollable": ""
    }
  }, [_c('v-card-title', {
    staticClass: "title grey lighten-4"
  }, [_vm._v("\n      Consumable Category\n      "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "small": "",
      "icon": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.manageConsCat = false
      }
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)], 1), _vm._v(" "), _c('v-card-text', [_c('v-flex', {
    staticClass: "mx-auto",
    attrs: {
      "xs12": "",
      "sm9": "",
      "md12": ""
    }
  }, [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    staticClass: "mb-0",
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "color": "accent",
      "flat": ""
    },
    on: {
      "click": _vm.createManageCons
    }
  }, [_vm._v("Add New")]), _vm._v(" "), _c('v-data-table', {
    staticClass: "elevation-1",
    attrs: {
      "headers": _vm.ManageConsHead,
      "items": _vm.consCatList,
      "hide-actions": "",
      "disable-initial-sort": ""
    },
    scopedSlots: _vm._u([{
      key: "items",
      fn: function(props) {
        return [_c('tr', {
          on: {
            "click": function($event) {
              return _vm.prepareConsEdit(props.item)
            }
          }
        }, [_c('td', [_vm._v(_vm._s(props.item.cons_cat))])])]
      }
    }], null, false, 3488283517)
  })], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.lConsAction === 'create' || _vm.lConsAction === 'update') ? _c('v-container', {
    staticClass: "pa-0"
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-form', {
    ref: "ccForm",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.saveConsCat(_vm.lConsAction)
      }
    }
  }, [_c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-flex', {
    staticClass: "mx-auto",
    attrs: {
      "xs12": "",
      "md11": ""
    }
  }, [_c('v-card-title', {
    staticClass: "title pb-0"
  }, [_vm._v("\n              " + _vm._s(_vm.handy.startWithUpper(_vm.lConsAction) + ' Consumable Category') + "\n            ")]), _vm._v(" "), _c('v-card-text', [_c('v-text-field', {
    attrs: {
      "label": "Category name",
      "rules": [_vm.rules.required],
      "hide-details": "",
      "maxlength": "100"
    },
    model: {
      value: (_vm.lConsCat.cons_cat),
      callback: function($$v) {
        _vm.$set(_vm.lConsCat, "cons_cat", $$v)
      },
      expression: "lConsCat.cons_cat"
    }
  })], 1)], 1), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.cancelChangesConsCat($event)
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), (_vm.lConsAction === 'update') ? _c('v-btn', {
    attrs: {
      "flat": "",
      "disabled": _vm.beingSaved
    },
    on: {
      "click": function($event) {
        return _vm.deleteConsCat(_vm.lConsCat)
      }
    }
  }, [_vm._v("Delete")]) : _vm._e(), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": "",
      "type": "submit",
      "color": "accent",
      "disabled": _vm.beingSaved
    }
  }, [_vm._v("Save")])], 1)], 1)], 1)], 1)], 1)], 1) : _vm._e()], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "persistent": "",
      "max-width": "500px"
    },
    model: {
      value: (_vm.showHist),
      callback: function($$v) {
        _vm.showHist = $$v
      },
      expression: "showHist"
    }
  }, [(_vm.lSHAction === 'view') ? _c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-card-title', {
    staticClass: "pa-2 subheading font-weight-bold grey lighten-4"
  }, [_vm._v("\n      " + _vm._s(_vm.lAsset.asset_cat + ': ' + _vm.lAsset.asset_name) + "\n      "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "small": "",
      "icon": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.showHist = false
      }
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)], 1), _vm._v(" "), _c('v-card-text', [_c('v-flex', {
    staticClass: "mx-auto",
    attrs: {
      "xs12": "",
      "sm9": "",
      "md12": ""
    }
  }, [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    staticClass: "mb-0",
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "color": "accent",
      "flat": ""
    },
    on: {
      "click": _vm.prepareCreateServiceHist
    }
  }, [_vm._v("Add New")]), _vm._v(" "), _c('v-data-table', {
    staticClass: "elevation-1",
    attrs: {
      "headers": _vm.$vuetify.breakpoint.smAndUp ? _vm.assHistHead : _vm.assHistHeadsm,
      "items": _vm.histList,
      "hide-actions": "",
      "disable-initial-sort": ""
    },
    scopedSlots: _vm._u([{
      key: "items",
      fn: function(props) {
        return [_c('tr', {
          on: {
            "click": function($event) {
              return _vm.prepareEditHist(props.item)
            }
          }
        }, [_c('td', [_vm._v(_vm._s(_vm.handy.formatDate(props.item.service_hist_dt)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.service_hist_desc))]), _vm._v(" "), (_vm.$vuetify.breakpoint.smAndUp) ? _c('td', [_vm._v(_vm._s(props.item.service_hist_cost ? _vm.handy.formatCur(props.item.service_hist_cost) : ''))]) : _vm._e()])]
      }
    }], null, false, 241459489)
  })], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.lSHAction === 'create' || _vm.lSHAction === 'update') ? _c('v-container', {
    staticClass: "pa-0"
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-form', {
    ref: "shForm",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.saveServiceHistory(_vm.lSHAction)
      }
    }
  }, [_c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-card-title', {
    staticClass: "pa-1 subheading font-weight-bold grey lighten-4"
  }, [_vm._v("\n            " + _vm._s(_vm.lAsset.asset_name) + "\n            "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "small": "",
      "icon": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.lSHAction = 'view'
      }
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)], 1), _vm._v(" "), _c('v-card-title', {
    staticClass: "subheading font-weight-bold pb-0"
  }, [_vm._v("\n            " + _vm._s(_vm.handy.startWithUpper(_vm.lSHAction) + ' Service History') + "\n          ")]), _vm._v(" "), _c('v-card-text', [_c('v-flex', {
    staticClass: "mx-auto",
    attrs: {
      "xs12": "",
      "md11": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-dialog', {
    ref: "dlgservicehistDt",
    staticClass: "pt-0",
    attrs: {
      "persistent": "",
      "lazy": "",
      "max-width": "290px",
      "return-value": _vm.lHist.service_hist_dt
    },
    on: {
      "update:returnValue": function($event) {
        return _vm.$set(_vm.lHist, "service_hist_dt", $event)
      },
      "update:return-value": function($event) {
        return _vm.$set(_vm.lHist, "service_hist_dt", $event)
      }
    },
    model: {
      value: (_vm.dlgservicehistDt),
      callback: function($$v) {
        _vm.dlgservicehistDt = $$v
      },
      expression: "dlgservicehistDt"
    }
  }, [_c('v-text-field', {
    attrs: {
      "slot": "activator",
      "label": "Service date",
      "append-icon": "event",
      "readonly": "",
      "hide-details": ""
    },
    slot: "activator",
    model: {
      value: (_vm.lHist.service_hist_dt),
      callback: function($$v) {
        _vm.$set(_vm.lHist, "service_hist_dt", $$v)
      },
      expression: "lHist.service_hist_dt"
    }
  }), _vm._v(" "), _c('v-date-picker', {
    attrs: {
      "scrollable": "",
      "first-day-of-week": "1"
    },
    model: {
      value: (_vm.lHist.service_hist_dt),
      callback: function($$v) {
        _vm.$set(_vm.lHist, "service_hist_dt", $$v)
      },
      expression: "lHist.service_hist_dt"
    }
  }, [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": ""
    },
    on: {
      "click": function($event) {
        _vm.dlgservicehistDt = false
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": "",
      "color": "accent"
    },
    on: {
      "click": function($event) {
        return _vm.$refs.dlgservicehistDt.save(_vm.lHist.service_hist_dt)
      }
    }
  }, [_vm._v("OK")])], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Service description",
      "rules": [_vm.rules.required],
      "hide-details": "",
      "maxlength": "1000"
    },
    model: {
      value: (_vm.lHist.service_hist_desc),
      callback: function($$v) {
        _vm.$set(_vm.lHist, "service_hist_desc", $$v)
      },
      expression: "lHist.service_hist_desc"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "md6": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Service cost",
      "rules": [_vm.rules.required],
      "hide-details": "",
      "type": "number"
    },
    model: {
      value: (_vm.lHist.service_hist_cost),
      callback: function($$v) {
        _vm.$set(_vm.lHist, "service_hist_cost", $$v)
      },
      expression: "lHist.service_hist_cost"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-combobox', {
    attrs: {
      "label": "Choose vendor",
      "items": _vm.vendors.map(function (rec) { return rec.vendor_name; }),
      "maxlength": "50",
      "hide-details": "",
      "clearable": ""
    },
    on: {
      "input": function($event) {
        return _vm.findVendor(_vm.lHist)
      }
    },
    model: {
      value: (_vm.lHist.vendor_name),
      callback: function($$v) {
        _vm.$set(_vm.lHist, "vendor_name", $$v)
      },
      expression: "lHist.vendor_name"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "md6": ""
    }
  }, [_c('v-dialog', {
    ref: "dlgnextservicehistDt",
    staticClass: "pt-0",
    attrs: {
      "persistent": "",
      "lazy": "",
      "max-width": "290px",
      "return-value": _vm.lHist.next_service_due_dt
    },
    on: {
      "update:returnValue": function($event) {
        return _vm.$set(_vm.lHist, "next_service_due_dt", $event)
      },
      "update:return-value": function($event) {
        return _vm.$set(_vm.lHist, "next_service_due_dt", $event)
      }
    },
    model: {
      value: (_vm.dlgnextservicehistDt),
      callback: function($$v) {
        _vm.dlgnextservicehistDt = $$v
      },
      expression: "dlgnextservicehistDt"
    }
  }, [_c('v-text-field', {
    attrs: {
      "slot": "activator",
      "label": "Next service due date",
      "append-icon": "event",
      "readonly": "",
      "hide-details": ""
    },
    slot: "activator",
    model: {
      value: (_vm.lHist.next_service_due_dt),
      callback: function($$v) {
        _vm.$set(_vm.lHist, "next_service_due_dt", $$v)
      },
      expression: "lHist.next_service_due_dt"
    }
  }), _vm._v(" "), _c('v-date-picker', {
    attrs: {
      "scrollable": "",
      "min": _vm.today,
      "first-day-of-week": "1"
    },
    model: {
      value: (_vm.lHist.next_service_due_dt),
      callback: function($$v) {
        _vm.$set(_vm.lHist, "next_service_due_dt", $$v)
      },
      expression: "lHist.next_service_due_dt"
    }
  }, [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": ""
    },
    on: {
      "click": function($event) {
        _vm.dlgnextservicehistDt = false
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": "",
      "color": "accent"
    },
    on: {
      "click": function($event) {
        return _vm.$refs.dlgnextservicehistDt.save(_vm.lHist.next_service_due_dt)
      }
    }
  }, [_vm._v("OK")])], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.cancelChangesServHist($event)
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), (_vm.lSHAction === 'update') ? _c('v-btn', {
    attrs: {
      "flat": "",
      "disabled": _vm.beingSaved
    },
    on: {
      "click": function($event) {
        return _vm.deleteServiceHist(_vm.lHist)
      }
    }
  }, [_vm._v("Delete")]) : _vm._e(), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": "",
      "type": "submit",
      "color": "accent",
      "disabled": _vm.beingSaved
    }
  }, [_vm._v("Save")])], 1)], 1)], 1)], 1)], 1)], 1) : _vm._e()], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "persistent": "",
      "max-width": "400px"
    },
    model: {
      value: (_vm.showStock),
      callback: function($$v) {
        _vm.showStock = $$v
      },
      expression: "showStock"
    }
  }, [_c('v-container', {
    staticClass: "pa-0",
    attrs: {
      "grid-list-md": "",
      "fluid": "",
      "full-height": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "mx-auto": ""
    }
  }, [_c('v-form', {
    ref: "stForm",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.saveStock()
      }
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "title grey lighten-4"
  }, [_vm._v("\n            " + _vm._s(_vm.lStock.cons_name) + "\n            "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "small": "",
      "icon": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.cancelStockChanges($event)
      }
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)], 1), _vm._v(" "), _c('v-card-text', [_c('v-layout', {
    staticClass: "pb-3",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-dialog', {
    ref: "dlgStockpurchaseDt",
    staticClass: "pt-0",
    attrs: {
      "persistent": "",
      "lazy": "",
      "max-width": "290px",
      "return-value": _vm.lStock.purchase_or_cons_dt
    },
    on: {
      "update:returnValue": function($event) {
        return _vm.$set(_vm.lStock, "purchase_or_cons_dt", $event)
      },
      "update:return-value": function($event) {
        return _vm.$set(_vm.lStock, "purchase_or_cons_dt", $event)
      }
    },
    model: {
      value: (_vm.dlgStockconspurchaseDt),
      callback: function($$v) {
        _vm.dlgStockconspurchaseDt = $$v
      },
      expression: "dlgStockconspurchaseDt"
    }
  }, [_c('v-text-field', {
    attrs: {
      "slot": "activator",
      "label": _vm.stockLabel,
      "append-icon": "event",
      "readonly": "",
      "hide-details": ""
    },
    slot: "activator",
    model: {
      value: (_vm.lStock.purchase_or_cons_dt),
      callback: function($$v) {
        _vm.$set(_vm.lStock, "purchase_or_cons_dt", $$v)
      },
      expression: "lStock.purchase_or_cons_dt"
    }
  }), _vm._v(" "), _c('v-date-picker', {
    attrs: {
      "scrollable": "",
      "first-day-of-week": "1"
    },
    model: {
      value: (_vm.lStock.purchase_or_cons_dt),
      callback: function($$v) {
        _vm.$set(_vm.lStock, "purchase_or_cons_dt", $$v)
      },
      expression: "lStock.purchase_or_cons_dt"
    }
  }, [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": ""
    },
    on: {
      "click": function($event) {
        _vm.dlgStockconspurchaseDt = false
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": "",
      "color": "accent"
    },
    on: {
      "click": function($event) {
        return _vm.$refs.dlgStockpurchaseDt.save(_vm.lStock.purchase_or_cons_dt)
      }
    }
  }, [_vm._v("OK")])], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Quantity",
      "rules": [_vm.rules.required],
      "hide-details": "",
      "type": "number"
    },
    model: {
      value: (_vm.lStock.stock_qty),
      callback: function($$v) {
        _vm.$set(_vm.lStock, "stock_qty", $$v)
      },
      expression: "lStock.stock_qty"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "mt-4 subheading",
    attrs: {
      "xs6": ""
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.lCons.cons_uom))])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Consumable Location",
      "hide-details": "",
      "maxlength": "200"
    },
    model: {
      value: (_vm.lStock.stock_desc),
      callback: function($$v) {
        _vm.$set(_vm.lStock, "stock_desc", $$v)
      },
      expression: "lStock.stock_desc"
    }
  })], 1)], 1), _vm._v(" "), _c('v-card', {
    attrs: {
      "dark": "",
      "color": "info"
    }
  }, [_c('v-card-text', {
    staticClass: "pa-1"
  }, [_c('div', {
    staticClass: "text-xs-center"
  }, [_c('div', {
    staticClass: "subheading"
  }, [_vm._v("\n                Closing Stock: "), _c('span', {
    staticClass: "yellow--text title"
  }, [_vm._v(_vm._s(_vm.newStock + ' ' + _vm.lCons.cons_uom))])]), _vm._v(" "), _c('div', [_vm._v("\n                [ Prev. Stock " + _vm._s(_vm.lCons.cons_stock_uom + (_vm.lStock.stock_action === 'I' ? ' +' : ' -')) + " New Stock " + _vm._s((_vm.lStock.stock_qty ? _vm.lStock.stock_qty + ' ' : '0 ') + _vm.lCons.cons_uom) + " ]\n              ")])])])], 1)], 1), _vm._v(" "), _c('v-card-actions', {
    staticClass: "pt-0"
  }, [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.cancelStockChanges($event)
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": "",
      "type": "submit",
      "color": "accent",
      "disabled": _vm.beingSaved
    }
  }, [_vm._v("Save")])], 1)], 1)], 1)], 1)], 1)], 1), _vm._v(" "), (_vm.lAction === 'upload') ? _c('v-container', {
    staticClass: "pa-0",
    attrs: {
      "grid-list-md": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-card-title', {
    staticClass: "title pa-0 pl-3"
  }, [_vm._v("\n          Upload Asset List\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "mt-3 text-xs-center primary--text",
    staticStyle: {
      "font-family": "'Satisfy', cursive",
      "font-size": "200%",
      "font-weight": "normal"
    }
  }, [_vm._v("In just 4 steps")]), _vm._v(" "), _c('v-card-text', {
    staticClass: "subheading"
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-chip', {
    staticClass: "primary--text",
    attrs: {
      "small": "",
      "disabled": "",
      "outline": ""
    }
  }, [_vm._v("Step 1")]), _vm._v(" "), _c('span', [_vm._v("Download template")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "float": "right"
    }
  }, [_c('form', {
    attrs: {
      "method": "get",
      "action": "../static/files/Smartility_Asset_List_Template.xlsx"
    }
  }, [_c('v-btn', {
    staticClass: "mt-0 mb-0",
    attrs: {
      "type": "submit",
      "small": ""
    }
  }, [_c('v-icon', [_vm._v("file_download")])], 1)], 1)])], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-chip', {
    staticClass: "primary--text",
    attrs: {
      "small": "",
      "disabled": "",
      "outline": ""
    }
  }, [_vm._v("Step 2")]), _vm._v(" "), _c('span', [_vm._v("Fill-in details as guided in template")])], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-chip', {
    staticClass: "primary--text",
    attrs: {
      "small": "",
      "disabled": "",
      "outline": ""
    }
  }, [_vm._v("Step 3")]), _vm._v(" "), _c('span', [_vm._v("Save as CSV "), _c('span', {
    staticClass: "caption"
  }, [_vm._v("(Comma delimited)")]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "caption grey--text pl-4 ml-4"
  }, [_c('span', {
    staticClass: "ml-4"
  }, [_vm._v("Go with OK/Yes when prompted while saving")])])])], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-chip', {
    staticClass: "primary--text",
    attrs: {
      "small": "",
      "disabled": "",
      "outline": ""
    }
  }, [_vm._v("Step 4")]), _vm._v(" "), _c('span', [_vm._v("Upload the CSV file")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "float": "right"
    }
  }, [_c('v-btn', {
    staticClass: "mt-0 mb-0 accent",
    attrs: {
      "small": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.promptUpload($event)
      }
    }
  }, [_c('v-icon', [_vm._v("file_upload")])], 1)], 1), _vm._v(" "), _c('input', {
    ref: "ipFile",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "type": "file",
      "accept": ".csv"
    },
    on: {
      "change": function($event) {
        return _vm.validateFile()
      }
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('div', {
    staticClass: "mt-3 text-xs-center primary--text",
    staticStyle: {
      "font-family": "'Satisfy', cursive",
      "font-size": "200%",
      "font-weight": "normal"
    }
  }, [_vm._v("Uniservice takes care of rest")])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-chip', {
    staticClass: "primary--text",
    attrs: {
      "small": "",
      "disabled": "",
      "outline": ""
    }
  }, [_vm._v("Step 4")]), _vm._v(" "), _c('span', [_vm._v("Validate your information")])], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-chip', {
    staticClass: "primary--text",
    attrs: {
      "small": "",
      "disabled": "",
      "outline": ""
    }
  }, [_vm._v("Step 5")]), _vm._v(" "), _c('span', [_vm._v("Create Asset List")])], 1)], 1)], 1), _vm._v(" "), _c('v-card-actions', {
    staticClass: "pt-0 pr-4"
  }, [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    nativeOn: {
      "click": function($event) {
        return _vm.cancelChanges($event)
      }
    }
  }, [_vm._v("Cancel")])], 1)], 1)], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.lAction === 'validate') ? _c('v-container', {
    staticClass: "pa-0",
    attrs: {
      "grid-list-md": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-card-title', {
    staticClass: "title pa-0 pl-3"
  }, [_vm._v("\n          Upload Asset List\n        ")]), _vm._v(" "), _c('v-card-text', {
    staticClass: "text-xs-center pl-2 pr-2"
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "md9": "",
      "mx-auto": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "info--text mb-2",
    attrs: {
      "xs12": ""
    }
  }, [(_vm.validateInProgress) ? _c('span', [_vm._v("Loading and validating the file...")]) : _vm._e(), _vm._v(" "), (_vm.validFile && !_vm.validateInProgress) ? _c('span', [_vm._v("File validation is successfull "), _c('v-icon', {
    staticClass: "success--text"
  }, [_vm._v("check")])], 1) : _vm._e(), _vm._v(" "), (!_vm.validFile) ? _c('span', [_vm._v("File validation is failed "), _c('v-icon', {
    staticClass: "error--text"
  }, [_vm._v("close")])], 1) : _vm._e(), _vm._v(" "), (!_vm.validFile && _vm.headerIssue) ? _c('span', {
    staticClass: "error--text"
  }, [_c('br'), _vm._v("Invalid column headers, please ensure names and count are matching as per the template")]) : _vm._e(), _vm._v(" "), (!_vm.validFile && !_vm.headerIssue) ? _c('span', {
    staticClass: "error--text"
  }, [_c('br'), _vm._v("One or more invalid records, review the table below."), _c('br'), _vm._v("Click on the errored row to know more info.")]) : _vm._e(), _vm._v(" "), (!_vm.totFail && !_vm.loadInProgress) ? _c('span', [_vm._v("Asset list upload was successfull"), _c('v-icon', {
    staticClass: "success--text"
  }, [_vm._v("check")])], 1) : _vm._e(), _vm._v(" "), (!_vm.totLoaded && _vm.totFail && !_vm.loadInProgress) ? _c('span', [_c('br'), _vm._v("Asset list upload has failed"), _c('v-icon', {
    staticClass: "error--text"
  }, [_vm._v("close")])], 1) : _vm._e(), _vm._v(" "), (_vm.totLoaded && _vm.totFail && !_vm.loadInProgress) ? _c('span', [_c('br'), _vm._v("Asset list upload partially failed"), _c('v-icon', {
    staticClass: "warning--text"
  }, [_vm._v("close")])], 1) : _vm._e(), _vm._v(" "), (_vm.totFail && !_vm.loadInProgress) ? _c('span', {
    staticClass: "error--text"
  }, [_c('br'), _vm._v("One or more failed records, review the table below."), _c('br'), _vm._v("Click on the errored row to know more info.")]) : _vm._e()]), _vm._v(" "), (_vm.totRecs) ? _c('v-flex', {
    attrs: {
      "xs4": ""
    }
  }, [_c('v-progress-circular', {
    attrs: {
      "color": "info",
      "value": _vm.readyForLoad ? 100 : (_vm.recsLoaded.length / _vm.totRecs * 100),
      "size": 50,
      "width": 7
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.readyForLoad ? _vm.totValid : _vm.recsLoaded.length) + "\n                ")]), _vm._v(" "), _c('br'), _c('div', {
    staticClass: "caption grey--text"
  }, [_vm._v("Records")])], 1) : _vm._e(), _vm._v(" "), (_vm.totRecs) ? _c('v-flex', {
    attrs: {
      "xs4": ""
    }
  }, [_c('v-progress-circular', {
    attrs: {
      "color": "success",
      "value": (_vm.totValid / _vm.totRecs * 100),
      "size": 50,
      "width": 7
    }
  }, [_vm._v("\n                " + _vm._s(_vm.readyForLoad ? _vm.totLoaded : _vm.totValid) + "\n              ")]), _vm._v(" "), _c('br'), _c('div', {
    staticClass: "caption grey--text"
  }, [_vm._v(_vm._s(_vm.readyForLoad ? 'Loaded' : 'Valid'))])], 1) : _vm._e(), _vm._v(" "), (_vm.totRecs) ? _c('v-flex', {
    attrs: {
      "xs4": ""
    }
  }, [_c('v-progress-circular', {
    attrs: {
      "color": "error",
      "value": (_vm.totInvalid / _vm.totRecs * 100),
      "size": 50,
      "width": 7
    }
  }, [_vm._v("\n              " + _vm._s(_vm.readyForLoad ? _vm.totFail : _vm.totInvalid) + "\n            ")]), _vm._v(" "), _c('br'), _c('div', {
    staticClass: "caption grey--text"
  }, [_vm._v(_vm._s(_vm.readyForLoad ? 'Failed' : 'Invalid'))])], 1) : _vm._e(), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-btn', {
    attrs: {
      "small": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.lAction = 'upload'
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), (_vm.totValid > 0) ? _c('v-btn', {
    staticClass: "accent",
    attrs: {
      "small": "",
      "disabled": _vm.beingSaved
    },
    nativeOn: {
      "click": function($event) {
        return _vm.uploadAsset($event)
      }
    }
  }, [_vm._v("Process the valid records")]) : _vm._e()], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-layout', [_c('v-flex', {
    staticClass: "mt-2",
    attrs: {
      "xs12": ""
    }
  }, [_c('v-data-table', {
    staticClass: "elevation-3 text-xs-left",
    attrs: {
      "headers": _vm.loadHeadSm,
      "items": _vm.recsLoaded,
      "hide-actions": "",
      "disable-initial-sort": ""
    },
    scopedSlots: _vm._u([{
      key: "items",
      fn: function(props) {
        return [_c('tr', {
          class: (props.item.error ? (props.item.load_status === 'Failed' ? 'error' : 'error--text') : (props.item.load_status === 'Loaded' ? 'success' : '')),
          on: {
            "click": function($event) {
              props.item.error ? _vm.showError(props.item.error) : ''
            }
          }
        }, [_c('td', [_vm._v(_vm._s(props.item.asset_cat))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.asset_name))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.asset_location))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.asset_qty))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.asset_status))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.is_critical))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.asset_tag))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.asset_spec))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.asset_value))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.purchased_dt))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.warranty_start_dt))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.warranty_end_dt))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.amc_start_dt))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.amc_due_dt))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.vendor_name))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.next_service_due_dt))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.remark))])])]
      }
    }], null, false, 3307011167)
  })], 1)], 1)], 1), _vm._v(" "), (false) ? _c('v-card-actions', {
    staticClass: "pt-0"
  }, [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.cancelChanges($event)
      }
    }
  }, [_vm._v("Cancel")])], 1) : _vm._e()], 1)], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.lAction === 'upload-serviceHistory') ? _c('v-container', {
    staticClass: "pa-0",
    attrs: {
      "grid-list-md": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-card-title', {
    staticClass: "title pa-0 pl-3"
  }, [_vm._v("\n          Upload Asset Service History\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "mt-3 text-xs-center primary--text",
    staticStyle: {
      "font-family": "'Satisfy', cursive",
      "font-size": "200%",
      "font-weight": "normal"
    }
  }, [_vm._v("In just 5 steps")]), _vm._v(" "), _c('v-card-text', {
    staticClass: "subheading"
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs3": ""
    }
  }, [_c('v-chip', {
    staticClass: "primary--text",
    attrs: {
      "small": "",
      "disabled": "",
      "outline": ""
    }
  }, [_vm._v("Step 1")]), _vm._v(" "), _c('span', [_vm._v("Select assets")])], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "pt-0",
    attrs: {
      "xs3": ""
    }
  }, [_c('v-select', {
    staticClass: "pt-0",
    attrs: {
      "label": "Asset Type",
      "items": ['Critical', 'Non-Critical', 'All'],
      "hide-details": "",
      "small-chips": "",
      "clearable": "",
      "multiple": ""
    },
    on: {
      "input": function($event) {
        return _vm.searchAssets()
      }
    },
    model: {
      value: (_vm.lUpload.assetTypes),
      callback: function($$v) {
        _vm.$set(_vm.lUpload, "assetTypes", $$v)
      },
      expression: "lUpload.assetTypes"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-chip', {
    staticClass: "primary--text",
    attrs: {
      "small": "",
      "disabled": "",
      "outline": ""
    }
  }, [_vm._v("Step 2")]), _vm._v(" "), _c('span', [_vm._v("Download template as csv")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "float": "right"
    }
  }, [_c('v-download-as', {
    attrs: {
      "headers": _vm.assetServiceHead,
      "items": _vm.assetList,
      "title": "Asset Service History",
      "landscape": true,
      "fontsize": 8
    }
  })], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-chip', {
    staticClass: "primary--text",
    attrs: {
      "small": "",
      "disabled": "",
      "outline": ""
    }
  }, [_vm._v("Step 3")]), _vm._v(" "), _c('span', [_vm._v("Fill-in details as guided in template ")]), _vm._v(" "), _c('div', {
    staticClass: "caption grey--text pl-4 ml-4"
  }, [_c('span', {
    staticClass: "ml-4"
  }, [_vm._v("(Tip: "), _c('a', {
    staticStyle: {
      "text-decoration": "underline"
    },
    on: {
      "click": _vm.loadVendorList
    }
  }, [_vm._v("Click here")]), _vm._v(" to see the list of vendors )")])])], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-chip', {
    staticClass: "primary--text",
    attrs: {
      "small": "",
      "disabled": "",
      "outline": ""
    }
  }, [_vm._v("Step 4")]), _vm._v(" "), _c('span', [_vm._v("Save as CSV "), _c('span', {
    staticClass: "caption"
  }, [_vm._v("(Comma delimited)")]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "caption grey--text pl-4 ml-4"
  }, [_c('span', {
    staticClass: "ml-4"
  }, [_vm._v("Go with OK/Yes when prompted while saving")])])])], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-chip', {
    staticClass: "primary--text",
    attrs: {
      "small": "",
      "disabled": "",
      "outline": ""
    }
  }, [_vm._v("Step 5")]), _vm._v(" "), _c('span', [_vm._v("Upload the CSV file")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "float": "right"
    }
  }, [_c('v-btn', {
    staticClass: "mt-0 mb-0 accent",
    attrs: {
      "small": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.promptUpload($event)
      }
    }
  }, [_c('v-icon', [_vm._v("file_upload")])], 1)], 1), _vm._v(" "), _c('input', {
    ref: "ipFile",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "type": "file",
      "accept": ".csv"
    },
    on: {
      "change": function($event) {
        return _vm.validateServiceHistFile()
      }
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('div', {
    staticClass: "mt-3 text-xs-center primary--text",
    staticStyle: {
      "font-family": "'Satisfy', cursive",
      "font-size": "200%",
      "font-weight": "normal"
    }
  }, [_vm._v("Uniservice takes care of rest")])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-chip', {
    staticClass: "primary--text",
    attrs: {
      "small": "",
      "disabled": "",
      "outline": ""
    }
  }, [_vm._v("Step 6")]), _vm._v(" "), _c('span', [_vm._v("Validate your information")])], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-chip', {
    staticClass: "primary--text",
    attrs: {
      "small": "",
      "disabled": "",
      "outline": ""
    }
  }, [_vm._v("Step 7")]), _vm._v(" "), _c('span', [_vm._v("Create service history")])], 1)], 1)], 1), _vm._v(" "), _c('v-card-actions', {
    staticClass: "pt-0 pr-4"
  }, [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    nativeOn: {
      "click": function($event) {
        return _vm.cancelChanges($event)
      }
    }
  }, [_vm._v("Cancel")])], 1)], 1)], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.lAction === 'validate-serviceHistory') ? _c('v-container', {
    staticClass: "pa-0",
    attrs: {
      "grid-list-md": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-card-title', {
    staticClass: "title pa-0 pl-3"
  }, [_vm._v("\n          Upload Asset Service History List\n        ")]), _vm._v(" "), _c('v-card-text', {
    staticClass: "text-xs-center pl-2 pr-2"
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "md9": "",
      "mx-auto": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "info--text mb-2",
    attrs: {
      "xs12": ""
    }
  }, [(_vm.validateInProgress) ? _c('span', [_vm._v("Loading and validating the file...")]) : _vm._e(), _vm._v(" "), (_vm.validFile && !_vm.validateInProgress) ? _c('span', [_vm._v("File validation is successfull "), _c('v-icon', {
    staticClass: "success--text"
  }, [_vm._v("check")])], 1) : _vm._e(), _vm._v(" "), (!_vm.validFile) ? _c('span', [_vm._v("File validation is failed "), _c('v-icon', {
    staticClass: "error--text"
  }, [_vm._v("close")])], 1) : _vm._e(), _vm._v(" "), (!_vm.validFile && _vm.headerIssue) ? _c('span', {
    staticClass: "error--text"
  }, [_c('br'), _vm._v("Invalid column headers, please ensure names and count are matching as per the template")]) : _vm._e(), _vm._v(" "), (!_vm.validFile && !_vm.headerIssue) ? _c('span', {
    staticClass: "error--text"
  }, [_c('br'), _vm._v("One or more invalid records, review the table below."), _c('br'), _vm._v("Click on the errored row to know more info.")]) : _vm._e(), _vm._v(" "), (!_vm.totFail && !_vm.loadInProgress) ? _c('span', [_vm._v("Asset list upload was successfull"), _c('v-icon', {
    staticClass: "success--text"
  }, [_vm._v("check")])], 1) : _vm._e(), _vm._v(" "), (!_vm.totLoaded && _vm.totFail && !_vm.loadInProgress) ? _c('span', [_c('br'), _vm._v("Asset Service History list upload has failed"), _c('v-icon', {
    staticClass: "error--text"
  }, [_vm._v("close")])], 1) : _vm._e(), _vm._v(" "), (_vm.totLoaded && _vm.totFail && !_vm.loadInProgress) ? _c('span', [_c('br'), _vm._v("Asset Service History list upload partially failed"), _c('v-icon', {
    staticClass: "warning--text"
  }, [_vm._v("close")])], 1) : _vm._e(), _vm._v(" "), (_vm.totFail && !_vm.loadInProgress) ? _c('span', {
    staticClass: "error--text"
  }, [_c('br'), _vm._v("One or more failed records, review the table below."), _c('br'), _vm._v("Click on the errored row to know more info.")]) : _vm._e()]), _vm._v(" "), (_vm.totRecs) ? _c('v-flex', {
    attrs: {
      "xs4": ""
    }
  }, [_c('v-progress-circular', {
    attrs: {
      "color": "info",
      "value": _vm.readyForLoad ? 100 : (_vm.recSerHistLoaded.length / _vm.totRecs * 100),
      "size": 50,
      "width": 7
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.readyForLoad ? _vm.totValid : _vm.recSerHistLoaded.length) + "\n                ")]), _vm._v(" "), _c('br'), _c('div', {
    staticClass: "caption grey--text"
  }, [_vm._v("Records")])], 1) : _vm._e(), _vm._v(" "), (_vm.totRecs) ? _c('v-flex', {
    attrs: {
      "xs4": ""
    }
  }, [_c('v-progress-circular', {
    attrs: {
      "color": "success",
      "value": (_vm.totValid / _vm.totRecs * 100),
      "size": 50,
      "width": 7
    }
  }, [_vm._v("\n                " + _vm._s(_vm.readyForLoad ? _vm.totLoaded : _vm.totValid) + "\n              ")]), _vm._v(" "), _c('br'), _c('div', {
    staticClass: "caption grey--text"
  }, [_vm._v(_vm._s(_vm.readyForLoad ? 'Loaded' : 'Valid'))])], 1) : _vm._e(), _vm._v(" "), (_vm.totRecs) ? _c('v-flex', {
    attrs: {
      "xs4": ""
    }
  }, [_c('v-progress-circular', {
    attrs: {
      "color": "error",
      "value": (_vm.totInvalid / _vm.totRecs * 100),
      "size": 50,
      "width": 7
    }
  }, [_vm._v("\n              " + _vm._s(_vm.readyForLoad ? _vm.totFail : _vm.totInvalid) + "\n            ")]), _vm._v(" "), _c('br'), _c('div', {
    staticClass: "caption grey--text"
  }, [_vm._v(_vm._s(_vm.readyForLoad ? 'Failed' : 'Invalid'))])], 1) : _vm._e(), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-btn', {
    attrs: {
      "small": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.lAction = 'upload-serviceHistory'
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), (_vm.totValid > 0) ? _c('v-btn', {
    staticClass: "accent",
    attrs: {
      "small": "",
      "disabled": _vm.beingSaved || _vm.totFail > 0
    },
    nativeOn: {
      "click": function($event) {
        return _vm.uploadAssetServiceHist($event)
      }
    }
  }, [_vm._v("Process the valid records")]) : _vm._e()], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-layout', [_c('v-flex', {
    staticClass: "mt-2",
    attrs: {
      "xs12": ""
    }
  }, [_c('v-data-table', {
    staticClass: "elevation-3 text-xs-left",
    attrs: {
      "headers": _vm.assetServiceHead,
      "items": _vm.recSerHistLoaded,
      "hide-actions": "",
      "disable-initial-sort": ""
    },
    scopedSlots: _vm._u([{
      key: "items",
      fn: function(props) {
        return [_c('tr', {
          class: (props.item.error ? (props.item.load_status === 'Failed' ? 'error' : 'error--text') : (props.item.load_status === 'Loaded' ? 'success' : '')),
          on: {
            "click": function($event) {
              props.item.error ? _vm.showError(props.item.error) : ''
            }
          }
        }, [_c('td', [_vm._v(_vm._s(props.item.asset_id))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.asset_cat))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.asset_name))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.asset_tag))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.service_hist_dt))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.service_hist_desc))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.service_hist_cost))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.vendor_id))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.next_service_due_dt))])])]
      }
    }], null, false, 3299286277)
  })], 1)], 1)], 1), _vm._v(" "), (false) ? _c('v-card-actions', {
    staticClass: "pt-0"
  }, [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.cancelChanges($event)
      }
    }
  }, [_vm._v("Cancel")])], 1) : _vm._e()], 1)], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "persistent": "",
      "max-width": "1100px"
    },
    model: {
      value: (_vm.showConsReport),
      callback: function($$v) {
        _vm.showConsReport = $$v
      },
      expression: "showConsReport"
    }
  }, [_c('v-container', {
    staticClass: "pa-0",
    attrs: {
      "grid-list-md": "",
      "fluid": "",
      "full-height": ""
    }
  }, [_c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-card-title', {
    staticClass: "py-0 title grey lighten-4"
  }, [_vm._v("\n        " + _vm._s(_vm.consReport.cons_name) + "\n        "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "small": "",
      "icon": ""
    },
    on: {
      "click": function($event) {
        _vm.showConsReport = false
      }
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)], 1), _vm._v(" "), _c('v-card-text', {
    staticClass: "pa-0"
  }, [_c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-card-title', {
    staticClass: "pa-2"
  }, [_c('v-flex', {
    staticClass: "text-xs-center",
    attrs: {
      "xs6": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs5": ""
    }
  }, [_c('v-dialog', {
    ref: "fromDt",
    attrs: {
      "persistent": "",
      "lazy": "",
      "max-width": "290px",
      "return-value": _vm.consReport.from_dt
    },
    on: {
      "update:returnValue": function($event) {
        return _vm.$set(_vm.consReport, "from_dt", $event)
      },
      "update:return-value": function($event) {
        return _vm.$set(_vm.consReport, "from_dt", $event)
      }
    },
    model: {
      value: (_vm.fromDt),
      callback: function($$v) {
        _vm.fromDt = $$v
      },
      expression: "fromDt"
    }
  }, [_c('v-text-field', {
    attrs: {
      "slot": "activator",
      "label": "From Date",
      "append-icon": "event",
      "readonly": "",
      "clearable": "",
      "hide-details": "",
      "required": ""
    },
    slot: "activator",
    model: {
      value: (_vm.consReport.from_dt),
      callback: function($$v) {
        _vm.$set(_vm.consReport, "from_dt", $$v)
      },
      expression: "consReport.from_dt"
    }
  }), _vm._v(" "), _c('v-date-picker', {
    attrs: {
      "scrollable": "",
      "first-day-of-week": "1"
    },
    model: {
      value: (_vm.consReport.from_dt),
      callback: function($$v) {
        _vm.$set(_vm.consReport, "from_dt", $$v)
      },
      expression: "consReport.from_dt"
    }
  }, [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": ""
    },
    on: {
      "click": function($event) {
        _vm.fromDt = false
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": "",
      "color": "accent"
    },
    on: {
      "click": function($event) {
        return _vm.$refs.fromDt.save(_vm.consReport.from_dt)
      }
    }
  }, [_vm._v("OK")])], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs5": ""
    }
  }, [_c('v-dialog', {
    ref: "toDt",
    attrs: {
      "persistent": "",
      "lazy": "",
      "max-width": "290px",
      "return-value": _vm.consReport.to_dt
    },
    on: {
      "update:returnValue": function($event) {
        return _vm.$set(_vm.consReport, "to_dt", $event)
      },
      "update:return-value": function($event) {
        return _vm.$set(_vm.consReport, "to_dt", $event)
      }
    },
    model: {
      value: (_vm.toDt),
      callback: function($$v) {
        _vm.toDt = $$v
      },
      expression: "toDt"
    }
  }, [_c('v-text-field', {
    attrs: {
      "slot": "activator",
      "label": "To Date",
      "append-icon": "event",
      "readonly": "",
      "clearable": "",
      "hide-details": "",
      "required": ""
    },
    slot: "activator",
    model: {
      value: (_vm.consReport.to_dt),
      callback: function($$v) {
        _vm.$set(_vm.consReport, "to_dt", $$v)
      },
      expression: "consReport.to_dt"
    }
  }), _vm._v(" "), _c('v-date-picker', {
    attrs: {
      "scrollable": "",
      "first-day-of-week": "1"
    },
    model: {
      value: (_vm.consReport.to_dt),
      callback: function($$v) {
        _vm.$set(_vm.consReport, "to_dt", $$v)
      },
      expression: "consReport.to_dt"
    }
  }, [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": ""
    },
    on: {
      "click": function($event) {
        _vm.fromDt = false
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": "",
      "color": "accent"
    },
    on: {
      "click": function($event) {
        return _vm.$refs.toDt.save(_vm.consReport.to_dt)
      }
    }
  }, [_vm._v("OK")])], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "text-xs-center",
    attrs: {
      "xs2": ""
    }
  }, [_c('v-btn', {
    staticClass: "accent",
    attrs: {
      "small": "",
      "fab": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.prepareConsumableReport(_vm.consReport)
      }
    }
  }, [_vm._v("Go")])], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('v-download-as', {
    attrs: {
      "headers": _vm.repHead,
      "items": _vm.downloadConsReport,
      "title": "Consumable Report",
      "subtitle": _vm.consReport.cons_name + ' (' + _vm.handy.formatDate(_vm.consReport.from_dt) + ' to ' + _vm.handy.formatDate(_vm.consReport.to_dt) + ')',
      "fontsize": 8,
      "legend": 'Net closing stock: ' + (_vm.consReport.netStock ? _vm.consReport.netStock : 0),
      "landscape": true
    }
  })], 1)], 1), _vm._v(" "), _c('v-card-text', {
    staticClass: "pa-0"
  }, [_c('v-flex', {
    staticClass: "px-2 pt-0 pb-2",
    attrs: {
      "xs12": ""
    }
  }, [_c('v-data-table', {
    staticClass: "elevation-2",
    attrs: {
      "headers": _vm.repHead,
      "items": _vm.downloadConsReport,
      "hide-actions": ""
    },
    scopedSlots: _vm._u([{
      key: "items",
      fn: function(props) {
        return [(props.item.modify_by === 'Closing Stock') ? _c('tr', {
          style: ('font-weight: bold; color:#00000; background-color: #D5D8D0')
        }, [_c('td', {
          staticStyle: {
            "text-align": "left",
            "font-weight": "bold",
            "font-size": "13px"
          }
        }, [_vm._v(_vm._s(props.item.cons_name))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.purchase_or_cons_dt != '-' ? _vm.handy.formatDate(props.item.purchase_or_cons_dt) : ''))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.cust_name))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.previous_stock))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.pur_stock_qty))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.cons_stock_qty))]), _vm._v(" "), _c('td', {
          staticStyle: {
            "text-align": "left",
            "font-weight": "bold",
            "font-size": "13px"
          }
        }, [_vm._v(_vm._s(props.item.cons_stock))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.stock_desc))])]) : _c('tr', [_c('td', [_vm._v(_vm._s(props.item.cons_name))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.purchase_or_cons_dt != '-' ? _vm.handy.formatDate(props.item.purchase_or_cons_dt) : ''))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.cust_name))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.previous_stock))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.pur_stock_qty))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.cons_stock_qty))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.cons_stock))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.stock_desc))])])]
      }
    }])
  })], 1)], 1)], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "scrollable": "",
      "persistent": "",
      "max-width": "400px"
    },
    model: {
      value: (_vm.showVendorList),
      callback: function($$v) {
        _vm.showVendorList = $$v
      },
      expression: "showVendorList"
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "pa-1 ml-1 grey lighten-4 title"
  }, [_vm._v("\n      Choose vendor list\n      "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": "",
      "small": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.showVendorList = false
      }
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)], 1), _vm._v(" "), _c('v-card-text', [_c('v-data-table', {
    staticClass: "elevation-2",
    attrs: {
      "headers": _vm.vendorHeader,
      "items": _vm.vendors,
      "hide-actions": ""
    },
    scopedSlots: _vm._u([{
      key: "items",
      fn: function(props) {
        return [_c('tr', [_c('td', [_vm._v(_vm._s(props.item.vendor_id))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.vendor_name))])])]
      }
    }])
  })], 1)], 1)], 1), _vm._v(" "), _c('v-snackbar', {
    attrs: {
      "color": _vm.sbarCol,
      "timeout": 4000,
      "multi-line": ""
    },
    model: {
      value: (_vm.sbar),
      callback: function($$v) {
        _vm.sbar = $$v
      },
      expression: "sbar"
    }
  }, [_c('span', {
    staticClass: "mx-auto"
  }, [_vm._v(_vm._s(_vm.sbarMsg))])])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// C:/Users/vijay/L180/prototypes/uni-uswebapp/~/vue-loader/lib/template-compiler?{"id":"data-v-5dd328fe","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!C:/Users/vijay/L180/prototypes/uni-uswebapp/~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Inventory.vue
// module id = 855
// module chunks = 12